<div class="news-info">


  <div class="news-image">
    <img  src="{{imageService.changeImageUrl(news.photo)}}">
  </div>
  <div class="news-info">
    <h1 class="title">{{news.name}}</h1>
    <div class="description" [innerHTML] = 'getSanitize(news.text)'></div>
    <div class="date">{{news.date | date:" dd.MM.yyyy" }}</div>
  </div>
</div>
